import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSharp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.49999 1L5.49999 19M16.5 1L13.5 19M19.5 6H2.5M18.5 14H1.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSharp);
const Memo = memo(ForwardRef);
export default Memo;
